import { AbstractControl, ValidationErrors } from '@angular/forms';

export function TaxIdCodeValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim();

  return !value ||
    /^(?:[a-zA-Z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[A-EHLMPR-Ta-ehlmpr-t][0-9LMNPQRSTUVlmnpqrstuv]{2}[a-zA-Z][0-9LMNPQRSTUVlmnpqrstuv]{3}[a-zA-Z]|[0-9]{11})$/.test(
      value,
    )
    ? null
    : { taxIdCode: true };
}
